import React from 'react';
import { Link } from 'react-router-dom';
import HrnbButton from '../controls/HrnbButton';
import '../../css/components/duels/TournamentBracket.css';

/**
 * Компонент отображения сетки турнира
 * @param {Object} props
 * @param {Object} props.bracket - Данные сетки
 * @param {string} props.tournamentId - ID турнира
 */
function TournamentBracket({ bracket, tournamentId }) {
    if (!bracket || !bracket.stages || bracket.stages.length === 0) {
        return null;
    }

    const { stages } = bracket;

    // Определение ширины сетки
    const gridWidth = stages.length;

    return (
        <div className="tournament-bracket">
            <div className="tournament-bracket__stages" style={{ gridTemplateColumns: `repeat(${gridWidth}, 1fr)` }}>
                {stages.map((stage) => (
                    <div key={stage.id} className="tournament-bracket__stage">
                        <div className="tournament-bracket__stage-header">
                            <h3 className="tournament-bracket__stage-name">{stage.name}</h3>
                            <span className="tournament-bracket__stage-type">
                                {stage.type === 'SINGLE_ELIMINATION' ? 'Одиночное выбывание' : 
                                 stage.type === 'DOUBLE_ELIMINATION' ? 'Двойное выбывание' : 
                                 stage.type === 'ROUND_ROBIN' ? 'Круговая' : 'Швейцарская'}
                            </span>
                        </div>
                        <div className="tournament-bracket__matches">
                            {stage.matches.map((match) => (
                                <MatchCard 
                                    key={match.id} 
                                    match={match} 
                                    tournamentId={tournamentId}
                                />
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

/**
 * Карточка матча
 */
function MatchCard({ match, tournamentId }) {
    const {
        id,
        matchNumber,
        participant1,
        participant2,
        winnerId,
        status,
        scheduledAt,
        duelId
    } = match;

    const statusLabels = {
        PENDING: 'Ожидание',
        IN_PROGRESS: 'В процессе',
        COMPLETED: 'Завершён',
        SCHEDULED: 'Запланирован'
    };

    const formatTime = (dateString) => {
        if (!dateString) return '—';
        return new Date(dateString).toLocaleTimeString('ru-RU', {
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    return (
        <div className={`match-card match-card--${status.toLowerCase()}`}>
            <div className="match-card__header">
                <span className="match-card__number">Матч #{matchNumber}</span>
                <span className={`match-card__status match-card__status--${status.toLowerCase()}`}>
                    {statusLabels[status] || status}
                </span>
            </div>

            <div className="match-card__participants">
                <div className={`match-card__participant ${winnerId === participant1?.profileId ? 'match-card__participant--winner' : ''}`}>
                    {participant1 ? (
                        <>
                            <span className="match-card__participant-seed">
                                #{participant1.seed}
                            </span>
                            <Link
                                to={`/profile/${participant1.profileId}`}
                                className="match-card__participant-name"
                            >
                                {participant1.displayName}
                            </Link>
                        </>
                    ) : (
                        <span className="match-card__participant-empty">TBD</span>
                    )}
                </div>

                <div className={`match-card__participant ${winnerId === participant2?.profileId ? 'match-card__participant--winner' : ''}`}>
                    {participant2 ? (
                        <>
                            <span className="match-card__participant-seed">
                                #{participant2.seed}
                            </span>
                            <Link
                                to={`/profile/${participant2.profileId}`}
                                className="match-card__participant-name"
                            >
                                {participant2.displayName}
                            </Link>
                        </>
                    ) : (
                        <span className="match-card__participant-empty">TBD</span>
                    )}
                </div>
            </div>

            <div className="match-card__footer">
                <span className="match-card__time">
                    {formatTime(scheduledAt)}
                </span>
                {duelId && (
                    <Link to={`/duels/${duelId}`}>
                        <HrnbButton variant="primary" size="xs">
                            Дуэль
                        </HrnbButton>
                    </Link>
                )}
            </div>
        </div>
    );
}

export default TournamentBracket;
